import { type Action, type DataContainer, tracking } from '@otto-ec/tracking-bct';
import type { TrackingLabels } from './TrackingLabels';

class Tracker {
  private debug = false;

  enableDebug(): void {
    this.debug = true;
  }

  static convertLabelsToDataContainer(labels: Partial<TrackingLabels>): DataContainer {
    const dataContainer: DataContainer = {};

    Object.keys(labels).forEach((key) => {
      const value = labels[key as keyof TrackingLabels];
      if (value !== undefined) {
        dataContainer[key] = Array.isArray(value) ? value : [value];
      }
    });

    return dataContainer;
  }

  private logEvent(name: string, items: (object | string)[]) {
    if (this.debug) {
      const expandedItems = items.map((item) => {
        if (typeof item === 'object' && item !== null) {
          return JSON.stringify(item, null, 2);
        }
        return item;
      });
      console.log(name, ...expandedItems);
    }
  }

  addToPageImpression(labels: Partial<TrackingLabels>): void {
    this.logEvent('addToPageImpression', [labels]);
    tracking.submitMerge(Tracker.convertLabelsToDataContainer(labels));
  }

  trackOnNextPageImpression(labels: Partial<TrackingLabels>): void {
    this.logEvent('trackOnNextPageImpression', [labels]);
    tracking.trackOnNextPageImpression(Tracker.convertLabelsToDataContainer(labels));
  }

  submitClickEvent(labels: Partial<TrackingLabels>, variationId: string): void {
    this.logEvent('submitClickEvent', [labels]);

    const dataContainer: DataContainer = Tracker.convertLabelsToDataContainer(labels);

    const action: Action = {
      name: 'click',
      features: [
        {
          id: `P_${variationId}`,
          name: 'Product',
          status: 'visible',
          variationId,
        },
      ],
    };

    tracking.submitEvent(dataContainer, action);
  }
}

const tracker = new Tracker();
export default tracker;
